import { apiRequest } from "@alba-cars/common-modules";

import { PaginatedResponse } from "@/components/common/forms/FormAutoComplete";

export interface DealDriveModelVersion {
  node: {
    id: number;
    name: string;
    modelId: number;
  };
}

export const getDealDriveModelVersions = async (search?: string, brandId?: string, modelId?: string) => {
  if (!brandId || !modelId) {
    throw new Error("Brand ID and Model ID are required");
  }

  const queryParams = new URLSearchParams();
  if (search) {
    queryParams.append("search", search);
  }
  queryParams.append("brandId", brandId);
  queryParams.append("modelId", modelId);

  const response = await apiRequest<DealDriveModelVersion[]>(
    `/dealdrive/model-versions${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
    {
      next: {
        revalidate: 3600, // Cache for 1 hour
        tags: [`dealdrive-model-versions-${brandId}-${modelId}`],
      },
    },
  );

  return response;
};

export const getDealDriveModelVersionsPaginated = async (
  inputValue: string,
  page?: number,
  filter?: Record<string, string>,
): Promise<PaginatedResponse<{ label: string; value: string }>> => {
  try {
    // Only fetch if we have both brandId and modelId
    if (!filter?.brandId || !filter?.modelId) {
      return {
        data: [],
        meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
      };
    }

    const versions = await getDealDriveModelVersions(inputValue, filter.brandId, filter.modelId);

    const formattedVersions = versions.map((version) => ({
      label: version.node.name,
      value: version.node.id.toString(),
    }));

    return {
      data: formattedVersions,
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  } catch (error) {
    console.error("Error fetching DealDrive model versions:", error);
    return {
      data: [],
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  }
};
